export const cardBody = {
    width: "170px",
    height: "150px",
    padding: "10px",
    textAlign: "center"
};

export const image = {
    width: "130px",
    height: "130px",
    cursor: "pointer"
};

export const video_cardBody = {
    width: "170px",
    height: "200px",
    textAlign: "center"
};

export const video_listCardBody = {
    width: "100%",
    height: "150px",
    display: "flex",
    flexDirection: "row"
    // border: "1px solid black"
};

export const video_cardImage = {
    height: "150px",
    padding: "10px"
};

export const video_cardText = {
    height: "50px"
};

export const video_listCardText = {
    height: "130px",
    padding: "10px",
    cursor: "pointer"
};
